import type { StudentSchedulingDetails } from '../api/getStudentsSchedulingDetails';
import { isEnrollmentValid } from './isEnrollmentValid';

export const hasStudentRemainingSessions = (studentSchedulingDetails: StudentSchedulingDetails, timeZone: string): boolean => {
  if (studentSchedulingDetails.enrollments.length === 0) {
    return false;
  }

  if (studentSchedulingDetails.enrollments.some((enrollment) => isEnrollmentValid(enrollment, timeZone).valid === true)) {
    return true;
  }

  return false;
};
